import { FreeStuffEvaluationJobInfo, FreeStuffPolicyCategory } from 'aven_types'
import store from '../store'
import { log } from './logger'
import { getFreeStuffEvaluationJobInfo } from '../services/api'
import assert from 'assert'

export async function pollForTerminalFreeStuffEvaluationJobInfo(freeStuffPolicyCategory: FreeStuffPolicyCategory, jobId: string): Promise<FreeStuffEvaluationJobInfo> {
    const MAX_NUMBER_OF_POLLING_ATTEMPTS_PER_CALL = 50
    const DELAY_BETWEEN_POLLING_ATTEMPTS_MS = 3000
    log.info('pollForTerminalFreeStuffEvaluationJobInfo => Starting poll for free stuff evaluation job info')

    let freeStuffEvaluationJobInfo = await getAndStoreFreeStuffEvaluationJobInfo(freeStuffPolicyCategory, jobId)
    for (let numberOfAttempts = 0; numberOfAttempts < MAX_NUMBER_OF_POLLING_ATTEMPTS_PER_CALL; numberOfAttempts++) {
        log.info('pollForTerminalFreeStuffEvaluationJobInfo => Polling for free stuff evaluation job info attempt %{numberOfAttempts}', { numberOfAttempts })
        freeStuffEvaluationJobInfo = await getAndStoreFreeStuffEvaluationJobInfo(freeStuffPolicyCategory, jobId)
        if (freeStuffEvaluationJobInfo && freeStuffEvaluationJobInfo.continuePolling === false) {
            assert(
                !(freeStuffEvaluationJobInfo.freeStuffInfo && freeStuffEvaluationJobInfo.freeStuffInfo.terminalState == false && freeStuffEvaluationJobInfo.continuePolling === false),
                'should not have continuePolling == false if terminalState == false'
            )
            log.info('pollForTerminalFreeStuffEvaluationJobInfo => Free stuff evaluation job info indicates no more polling needed, stopping poll and updating store')
            store.commit('setFreeStuffEvaluationJobInfo', freeStuffEvaluationJobInfo)
            break
        }

        // Don't wait after last attempt
        if (numberOfAttempts < MAX_NUMBER_OF_POLLING_ATTEMPTS_PER_CALL - 1) {
            await new Promise((resolve) => setTimeout(resolve, DELAY_BETWEEN_POLLING_ATTEMPTS_MS))
        } else {
            log.info('pollForTerminalFreeStuffEvaluationJobInfo => Was not able to find terminal free stuff evaluation job info')
        }
    }
    return freeStuffEvaluationJobInfo
}

export async function getAndStoreFreeStuffEvaluationJobInfo(freeStuffPolicyCategory: FreeStuffPolicyCategory, jobId?: string): Promise<FreeStuffEvaluationJobInfo> {
    const freeStuffEvaluationJobInfoResponse = await getFreeStuffEvaluationJobInfo(freeStuffPolicyCategory, jobId)
    const freeStuffEvaluationJobInfo = freeStuffEvaluationJobInfoResponse.data.payload
    store.commit('setFreeStuffEvaluationJobInfo', freeStuffEvaluationJobInfo)
    return freeStuffEvaluationJobInfo
}
